/**
 * @generated SignedSource<<22e85cb200a6605f1f07673592bc8a6f>>
 * @relayHash b9b7589ed8cb475f0e0d41b90686da1d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4f0d3180e0b04177b64e3e59c0b52f6bccdaf043b1aa64e21acf263d98c033e3

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_fieldSetViewQuery$variables = {
  amountOfColumns: number;
  id: string;
};
export type ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_fieldSetViewQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_fieldSetViewQueryByProject">;
  } | null | undefined;
};
export type ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_fieldSetViewQuery = {
  response: ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_fieldSetViewQuery$data;
  variables: ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_fieldSetViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "amountOfColumns"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "displayName"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_fieldSetViewQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "amountOfColumns",
                "variableName": "amountOfColumns"
              }
            ],
            "kind": "FragmentSpread",
            "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_fieldSetViewQueryByProject"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_fieldSetViewQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasDefaultFieldSets"
              },
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "fieldSetSelectedState": "SELECTED"
                    }
                  },
                  {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "amountOfColumns"
                  }
                ],
                "concreteType": "JiraIssueSearchFieldSetConnection",
                "kind": "LinkedField",
                "name": "fieldSets",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraIssueSearchFieldSetEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssueSearchFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "fieldSetId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "type"
                          },
                          (v2/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "jqlTerm"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isSortable"
                          },
                          {
                            "concreteType": "JiraFieldSetPreferences",
                            "kind": "LinkedField",
                            "name": "fieldSetPreferences",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "width"
                              }
                            ]
                          },
                          {
                            "kind": "ClientExtension",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "isPlaceHolderField"
                              }
                            ]
                          },
                          {
                            "concreteType": "JiraFieldType",
                            "kind": "LinkedField",
                            "name": "fieldType",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "totalCount"
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__id"
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "JiraFieldSetView"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "4f0d3180e0b04177b64e3e59c0b52f6bccdaf043b1aa64e21acf263d98c033e3",
    "metadata": {},
    "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_fieldSetViewQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "242632a44472c0107adea6461f6f5fe4";

export default node;
